
import Metric from '../types/metric';
export default [
        {
            metric: "Labor Force",
            category: 'laborForce',
            code: "qtrs-mihe",
            topic: "LaborForce",
            source: "Local Area Unemployment Statistics (LAUS), Michigan Center for Data and Analytics, DTMB",
            rate: 'month',
            dateProp: 'date'
       },
       {  
            metric: "Labor Force Participation Rate",
            category: 'laborForce',
            code: "bfer-2y45",
            topic: "LaborForceParticipation",
            source: "Current Population Survey (CPS), Michigan Center for Data and Analytics, DTMB",
            rate: 'month',
            dateProp: 'date',
        }, 
        {
            metric: "Labor Force Participation Rate by State",
            category: 'laborForce',
            code: "r2du-fu4p",
            topic: "LaborPartByState",
            source: "Current Population Survey (CPS), Michigan Center for Data and Analytics, DTMB",
            rate: null,
            dateProp: '',
       },
       {
            metric: "Payroll Jobs",
            category: 'laborForce',
            code: "vyr4-4e6w",
            topic: "PayrollJobs",
            source: "Current Employment Statistics (CES), Michigan Center for Data and Analytics, DTMB",
            rate: 'month',
            dateProp: 'date',
        },
        {
            metric: "Household Employment",
            category: 'laborForce',
            code: "wbcm-qnpw",
            topic: "HouseEmploy",
            source: "Local Area Unemployment Statistics (LAUS), Michigan Center for Data and Analytics, DTMB",
            rate: 'month',
            dateProp: 'date',
       },
       {
            metric: "Percent of Population Employed",
            category: 'laborForce',
            code: "49zi-x7ny",
            topic: "PercentPopEmp",
            source: "Current Population Survey (CPS), Michigan Center for Data and Analytics, DTMB",
            rate: 'month',
            dateProp: 'date',
        },
        {
            metric: "Online Job Advertisements vs. Unemployed ",
            category: 'laborForce',
            code: "5esi-5inm",
            topic: "OnlineVsUnemploy",
            source: "Michigan Center for Data and Analytics, DTMB/ The Conference Board, Help Wanted Online Data Series",
            rate: 'month',
            dateProp: 'date',
        },
        {
            metric: "Private Sector Gross Job Gains & Losses",
            category: 'laborForce',
            code: "e2jz-aihp",
            topic: "PvtGrossJobGainLoss",
            source: "Business Employment Dynamics (BED), Michigan Center for Data and Analytics, DTMB",
            rate: 'quarter',
            dateProp: 'date',
        },
        {
            metric: "Covered Employment",
            category: 'laborForce',
            code: "ds45-bmgg",
            topic: "CoveredEmployment",
            source: "Quarterly Census of Employment and Wages (QCEW), Michigan Center for Data and Analytics, DTMB",
            rate: 'month',
            dateProp: 'date',
        },
        {
            metric: "Unemployment Rate",
            category: 'unemployment',
            code: "kamp-ngb9",
            topic: "Unemployment",
            source: "Local Area Unemployment Statistics (LAUS), Michigan Center for Data and Analytics, DTMB",
            rate: 'month',
            dateProp: 'date',
        },
        {
            metric: "Unemployment Rate by State",
            category: 'unemployment',
            code: "qj2w-9cqv",
            topic: "UnemployByState",
            source: "Current Population Survey (CPS), Michigan Center for Data and Analytics, DTMB",
            rate: null,
            dateProp: '',
        },
        {
            metric: "Unemployment Rate by Education Level",
            category: 'unemployment',
            code: "i3eb-9m3s",
            topic: "UnemployByEdu",
            source: "Current Population Survey (CPS), Michigan Center for Data and Analytics, DTMB",
            rate: 'month',
            dateProp: 'date',
        },
        {
            metric: "Youth Unemployment Rate (16 - 24 years old)",
            category: 'unemployment',
            code: "tdrw-5jnz",
            topic: "YouthUnemploy",
            source: "Current Population Survey (CPS), Michigan Center for Data and Analytics, DTMB",
            rate: 'month',
            dateProp: 'date',
        },
        {
            metric: "Measure of Labor Underutilization",
            category: 'unemployment',
            code: "qvy3-8uz3",
            topic: "LaborUnderUtil",
            source: "Current Population Survey (CPS), Michigan Center for Data and Analytics, DTMB",
            rate: 'quarter',
            dateProp: 'date',
        },
        {
            metric: "Part-Time Rates",
            category: 'unemployment',
            code: "wimi-7c6r",
            topic: "PartTimeRate",
            source: "Current Population Survey (CPS), Michigan Center for Data and Analytics, DTMB",
            rate: 'month',
            dateProp: 'date',
        },
        {
            metric: "Percent of Unemployed Long-Term Unemployed",
            category: 'unemployment',
            code: "tjgt-hsif",
            topic: "LongTermUnemploy",
            source: "Current Population Survey (CPS), Michigan Center for Data and Analytics, DTMB",
            rate: 'month',
            dateProp: 'date',
        },
        {
            metric: "Initial Claims For Unemployment Benefits (52 Week Moving Average) ",
            category: 'unemployment',
            code: "vsec-rvkn",
            topic: "InitClaim4Unemploy",
            source: "U.S. Department of Labor, Employment and Training Administration (ETA)",
            rate: 'month',
            dateProp: 'date',
       },
        {
            metric: "Private Sector Payroll Jobs",
            category: 'industryJobs',
            code: "wrfk-exg9",
            topic: "PriSecPayroll",
            source: "Current Employment Statistics (CES), Michigan Center for Data and Analytics, DTMB",
            rate: 'month',
            dateProp: 'date',
        },
        {
            metric: "Government Payroll Jobs ",
            category: 'industryJobs',
            code: "88ap-tatr",
            topic: "GovPayroll",
            source: "Current Employment Statistics (CES), Michigan Center for Data and Analytics, DTMB",
            rate: 'month',
            dateProp: 'date',
        },
        {
            metric: "Payroll Jobs: Manufacturing",
            category: 'industryJobs',
            code: "fp3t-3n5d",
            topic: "PayrollManufact",
            source: "Current Employment Statistics (CES), Michigan Center for Data and Analytics, DTMB",
            rate: 'month',
            dateProp: 'date',
        },
        {
            metric: "Average Hourly Earnings: Manufacturing",
            category: 'industryJobs',
            code: "bc9f-uqbe",
            topic: "AvgHrsEarnManufactur",
            source: "Current Employment Statistics (CES), Michigan Center for Data and Analytics, DTMB",
            rate: 'month',
            dateProp: 'date',
        },
        {
            metric: "Average Weekly Hours: Manufacturing",
            category: 'industryJobs',
            code: "vqnz-33cw",
            topic: "AvgWeekHrsManufactur",
            source: "Current Employment Statistics (CES), Michigan Center for Data and Analytics, DTMB",
            rate: 'month',
            dateProp: 'date',
        },
        {
            metric: "Payroll Jobs: Trade, Transportation, and Utilities",
            category: 'industryJobs',
            code: "igjn-gxcg",
            topic: "PayrollTrade",
            source: "Current Employment Statistics (CES), Michigan Center for Data and Analytics, DTMB",
            rate: 'month',
            dateProp: 'date',
        },
        {
            metric: "Payroll Jobs: Private Education and Health Services",
            category: 'industryJobs',
            code: "6c7m-7jr2",
            topic: "PayrollPrivateEduHeath",
            source: "Current Employment Statistics (CES), Michigan Center for Data and Analytics, DTMB",
            rate: 'month',
            dateProp: 'date',
        },
        {
            metric: "Payroll Jobs: Professional & Business Services",
            category: 'industryJobs',
            code: "suj4-2yhz",
            topic: "PayrollProBusiness",
            source: "Current Employment Statistics (CES), Michigan Center for Data and Analytics, DTMB",
            rate: 'month',
            dateProp: 'date',
        },
       
        {
            metric: "Payroll Jobs: Leisure & Hospitality",
            category: 'industryJobs',
            code: "myzu-iwzg",
            topic: "PayrollLeisure",
            source: "Current Employment Statistics (CES), Michigan Center for Data and Analytics, DTMB",
            rate: 'month',
            dateProp: 'date',
        },
        {
            metric: "Payroll Jobs: Financial Activities",
            category: 'industryJobs',
            code: "vcm5-dhbc",
            topic: "PayrollFA",
            source: "Current Employment Statistics (CES), Michigan Center for Data and Analytics, DTMB",
            rate: 'month',
            dateProp: 'date',
       },
        {
             metric: "Payroll Jobs: Other Services",
             category: 'industryJobs',
             code: "czfi-bwr8",
             topic: "PayrollOther",
             source: "Current Employment Statistics (CES), Michigan Center for Data and Analytics, DTMB",
             rate: 'month',
             dateProp: 'date',
        },
        {
             metric: "Payroll Jobs: Construction",
             category: 'industryJobs',
             code: "9u4j-e3u2",
             topic: "PayrollCon",
             source: "Current Employment Statistics (CES), Michigan Center for Data and Analytics, DTMB",
             rate: 'month',
             dateProp: 'date',
        },
        {
             metric: "Payroll Jobs: Information",
             category: 'industryJobs',
             code: "9jw7-ipev",
             topic: "PayrollInfo",
             source: "Current Employment Statistics (CES), Michigan Center for Data and Analytics, DTMB",
             rate: 'month',
             dateProp: 'date',
        },
        {
            metric: "Payroll Jobs: Mining & Logging",
            category: 'industryJobs',
            code: "g6ub-eizc",
            topic: "PayrollMineLog",
            source: "Current Employment Statistics (CES), Michigan Center for Data and Analytics, DTMB",
            rate: 'month',
            dateProp: 'date',
        },
        {
            metric: "U.S. Light Vehicle Sales",
            category: 'economy',
            code: "awi6-k3et",
            topic: "USLightVehicle",
            source: "Bureau of Economic Analysis",
            rate: 'month',
            dateProp: 'date',
        },
        {
            metric: "U.S. Retail Sales",
            category: 'economy',
            code: "954f-ercy",
            topic: "USRetail",
            source: "Bureau of the Census",
            rate: 'month',
            dateProp: 'date',
        },
        {
             metric: "Oil Prices",
             category: 'economy',
             code: "dx9e-uvnm",
             topic: "OilPrices",
             source: "St. Louis Federal Reserve Database",
             rate: 'month',
             dateProp: 'date',
        },
        {
            metric: "Natural Gas Prices",
            category: 'economy',
            code: "bknw-gxdr",
            topic: "NaturalGas",
            source: "St. Louis Federal Reserve Database",
            rate: 'month',
            dateProp: 'date',
        },
        {
            metric: "U.S. Housing Starts",
            category: 'economy',
            code: "ta3g-b6yy",
            topic: "USHousing",
            source: "Bureau of the Census",
            rate: 'month',
            dateProp: 'date',
        },
        {
            metric: "Michigan Building Permits",
            category: 'economy',
            code: "9a5w-et7j",
            topic: "BuildingPermit",
            source: "Bureau of the Census",
            rate: 'month',
            dateProp: 'date',
        },
        {
            metric: "Michigan Vehicle Production",
            category: 'economy',
            code: "7ufw-v8nq",
            topic: "VehicleProd",
            source: "Office of Revenue and Tax Analysis, Automotive News and Company Reports",
            rate: 'month',
            dateProp: 'month',
        },
        {
            metric: "Detroit Home Prices (Case-Shiller Index)",
            category: 'economy',
            code: "nfju-asiv",
            topic: "HomeIndexPrice",
            source: "S&P Dow Jones Indices and Fiserv",
            rate: 'month',
            dateProp: 'date',
        },
        {
            metric: "Michigan Per Capita Personal Income",
            category: 'economy',
            code: "7frj-2rv6",
            topic: "PerCapPersonal",
            source: "Bureau of Economic Analysis",
            rate: 'year',
            dateProp: 'year',
        },
        {
            metric: "Michigan Population",
            category: 'population',
            code: "4fpi-4kt2",
            topic: "MichiganPopuation",
            source: "Bureau of the Census",
            rate: 'year',
            dateProp: 'date',
        },
        {
            metric: "Michigan Real GDP",
            category: 'economy',
            code: "fcuc-ijab",
            topic: "MichiganGDP",
            source: "Bureau of Economic Analysis",
            rate: 'quarter',
            dateProp: 'date',
        },
        {
            metric: "Educational Attainment",
            category: 'population',
            code: "i24a-p6x8",
            topic: "EducationAttain",
            source: "One-Year Estimates, American Community Survey, U.S. Census Bureau",
            rate: 'year',
            dateProp: 'date',
        }

    ] as Array<Metric>;
